var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,14a6,6,0,0,0-6,6V80a6,6,0,0,0,6,6H80a6,6,0,0,0,6-6V14ZM81.5,80A1.5,1.5,0,0,1,80,81.5H20A1.5,1.5,0,0,1,18.5,80V20A1.5,1.5,0,0,1,20,18.5H81.5ZM50,55.22c9.58,0,17.84,3.48,21.69,8.51a4,4,0,0,1-3.18,6.36h-37a4,4,0,0,1-3.18-6.36C32.16,58.7,40.43,55.22,50,55.22Zm9.14-16.17A9.14,9.14,0,1,1,50,29.91,9.14,9.14,0,0,1,59.14,39.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox);
export default __webpack_public_path__ + "static/media/AccountBox.ee876d6e7c467309efff8fed912ab0fd.svg";
export { ForwardRef as ReactComponent };